// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3y2hh","right":"styles_right__12Eyl"};